// Internal Imports
import { get, put, post } from "../../api/index";
import { API_ENDPOINTS, GRID } from "../../constants";
import { GlobalUtils } from "../../utils";

// Method Imports
import { parseAppFlags } from "./commonMethods";

// Destructuring
const { PAGE_TO_APPVIEW_MAP } = GRID;
const { APIS } = API_ENDPOINTS;
const { readDataFromLocalStorage, writeDataToLocalStorage } = GlobalUtils;
export const fetchAppConfig = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.APP_VIEW_CONFIG}`)
      .then(res => {
        writeDataToLocalStorage("appView", res.App);
        resolve(res);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const fetchFlagConfig = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.ORGS}/flags`)
      .then(res => {
        const flagsObj = parseAppFlags(res.OrgFlags || []);
        writeDataToLocalStorage("appFlag", flagsObj);
        resolve(res);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const fetchUserSignUpInfo = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.AUTH}/signup_info`)
      .then(res => {
        writeDataToLocalStorage("userSignUpInfo", res.SignupInfo);
        resolve(res);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const getRbacRoles = async () => {
  const rbacRoles = await get(`${APIS.RBAC}/roles`)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return rbacRoles;
};

export const getColVisibilityList = async page => {
  const getAppView = readDataFromLocalStorage("appView");
  const view =
    getAppView && getAppView.views
      ? getAppView.views[PAGE_TO_APPVIEW_MAP[page]]
      : null;
  const colList = await get(`${APIS.RBAC}/column_visibility/${view}/`)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return colList;
};

export const updateColVisibilityList = async (payload, page) => {
  const getAppView = readDataFromLocalStorage("appView");
  const view =
    getAppView && getAppView.views
      ? getAppView.views[PAGE_TO_APPVIEW_MAP[page]]
      : null;
  const colList = await put(`${APIS.RBAC}/column_visibility/${view}/`, payload)
    .then(res => res)
    .catch(error => {
      throw error;
    });
  return colList;
};

export const checkInboxUnreadNotificationService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.GET_NOTIFICATIONS}/unseen`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });

export const sendFeatureRequest = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.SUPPORT_EMAIL}`, data)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getMeterUsageService = entity =>
  new Promise((resolve, reject) => {
    get(`${APIS.ORGS_METERS}?entity=${entity}&promotional_included=false`)
      .then(res => {
        // * Store entity map in local storage
        const meteredFeatureMap =
          res && res.meters && res.meters.feature_entity_mapping;
        delete meteredFeatureMap["quoting.pricebook"];
        delete meteredFeatureMap["wf.standard_variables"];
        delete meteredFeatureMap["wf.system.user_management"];
        writeDataToLocalStorage("featureEntityMap", meteredFeatureMap);

        // * Return the metered counter value
        const usage =
          res &&
          res.meters &&
          res.meters.entity_usage_meter &&
          res.meters.entity_usage_meter[entity];
        resolve(usage);
      })
      .catch(error => {
        reject(error);
      });
  });

export const apiPing = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.PING}`)
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/CommonActions/commonService.js